export default __webpack_public_path__ + "static/media/securityIcon.480b4ffc.svg";